"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-one/sections/testimonialSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import Slider from "react-slick";
import { FC, ComponentProps, Key, ReactNode } from "react";

type HomeOneTestimonialSectionHomeOneTestimonialSectionInlineCollection1Item = {
    /** Detected variants: "Excellent Service" */
    title?: string;
    /** Detected variants: "I had a wonderful experience. The staff was friendly and attentive, and the doctor explained everything clearly." */
    description?: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "/Templates/Doccure/img/patients/patient22.jpg" */
    image?: string;
    /** Detected variants: "img" */
    alt?: string;
    /** Detected variants: "John Doe" */
    author?: string;
    /** Detected variants: "United States" */
    location?: string;
};

type TestimonialSectionCountersItem = {
    key: Key | null | undefined;
    /** Detected variants: "+" | "%" */
    h40Text?: ReactNode;
    /** Detected variants: "display-6 success-count" | "display-6 secondary-count" | "display-6 purple-count" */
    className: string;
    /** Detected variants: "Doctors Available" | "Specialities" | "Health Packages" | "Lab Tests" | "Happy Patients" */
    p0Text: ReactNode;
    /** Detected variants: "counter-item text-center" */
    divClassName?: string;
    /** Detected variants: "isVisible && <CountUp end={500} duration={2} />" | "isVisible && <CountUp end={18} duration={2} />" | "isVisible && (\n                    <CountUp end={30} duration={2} suffix=\"K\" />\n                  )" | "isVisible && <CountUp end={100} duration={2} />" | "isVisible && <CountUp end={99} duration={2} />" */
    h40Expr0: ReactNode;
};
const settings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    responsive: [
        { breakpoint: 1400, settings: { slidesToShow: 3 } },
        { breakpoint: 1200, settings: { slidesToShow: 3 } },
        { breakpoint: 992, settings: { slidesToShow: 2 } },
        { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
};

export type HomeOneTestimonialSectionGeneratedProps = {
    homeOneTestimonialSectionInlineCollection1?: HomeOneTestimonialSectionHomeOneTestimonialSectionInlineCollection1Item[];
    divH40H4Props?: Partial<ComponentProps<"h4">> | ((item: TestimonialSectionCountersItem) => Partial<ComponentProps<"h4">>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Testimonials" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "Users" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    /** Default: "Worldwide" */
    sectionDiv0Div0H20H2Text2?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Trust Doccure" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    sectionDiv0Div1Div0ClassName?: string;
    sectionDiv0Slider0SliderProps?: Partial<ComponentProps<typeof Slider>>;
    testimonialSectionCounters: TestimonialSectionCountersItem[];
    testimonialSectionCountersItemWrapper?: (item: TestimonialSectionCountersItem, content: ReactNode) => ReactNode;
    testimonialSectionCountersRenderer?: (defaultNode: ReactNode) => ReactNode;
    testimonialSectionCountersH4Visible?: boolean;
    testimonialSectionCountersH4Renderer?: (item: TestimonialSectionCountersItem, defaultNode: ReactNode) => ReactNode;
    testimonialSectionCountersH4Props?: Partial<ComponentProps<"h4">> | ((item: TestimonialSectionCountersItem) => Partial<ComponentProps<"h4">>);
};

const HomeOneTestimonialSectionGenerated: FC<HomeOneTestimonialSectionGeneratedProps> = ({
    homeOneTestimonialSectionInlineCollection1 = [],
    sectionDiv0Div0Div0DivText = "Testimonials",
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Users",
    sectionDiv0Div0H20H2Text2 = "Worldwide",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "Trust Doccure",
    divH40H4Props,
    sectionDiv0Slider0SliderProps,
    sectionDiv0Div1Div0ClassName,
    testimonialSectionCounters,
    testimonialSectionCountersItemWrapper,
    testimonialSectionCountersRenderer,
    testimonialSectionCountersH4Visible,
    testimonialSectionCountersH4Renderer,
    testimonialSectionCountersH4Props,
}) => {
    return (
        <section className="testimonial-section-one section">
            <div className="container">
                <div className="section-header section-header-one text-center wow slideInLeft" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    <div className="title">{sectionDiv0Div0Div0DivText}</div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {" "}
                            {sectionDiv0Div0H20H2Text}
                            <span className="text-primary">{sectionDiv0Div0H20Span0SpanText}</span>
                            {sectionDiv0Div0H20H2Text2}
                        </h2>
                    ))}
                </div>
                <Slider {...settings} className="testimonials-slider" {...(sectionDiv0Slider0SliderProps ?? {})}>
                    {homeOneTestimonialSectionInlineCollection1.map((item, index) => (
                        <div className="slide-item" key={index}>
                            <div className="testimonials-item wow zoomOutDown" data-wow-duration="1s">
                                <div className="testimonials-info">
                                    <div className="review-star justify-content-between">
                                        <div className="rating d-flex">
                                            {Array.from({ length: 5 }).map((_, i) => (
                                                <i
                                                    key={i}
                                                    className="fa-solid fa-star filled me-1"
                                                />
                                            ))}
                                        </div>
                                        <span>
                                            <SmartImage src="/Templates/Doccure/img/icons/quote-icon.svg" alt="img" />
                                        </span>
                                    </div>
                                    <div className="testimonial-content">
                                        <h3 className="title">{item.title ?? "Excellent Service"}</h3>
                                        <p className="description">{item.description ?? "I had a wonderful experience. The staff was friendly and attentive, and the doctor explained everything clearly."}</p>
                                    </div>
                                    <div className="testimonial-author">
                                        <SmartLink href={item.href ?? "#"} className="avatar avatar-lg">
                                            <SmartImage src={item.image ?? "/Templates/Doccure/img/patients/patient22.jpg"} className="rounded-circle" alt={item.alt ?? "img"} />
                                        </SmartLink>
                                        <div>
                                            <p className="author-name">
                                                <SmartLink href={item.href ?? "#"}>{item.author ?? "John Doe"}</SmartLink>
                                            </p>
                                            <p className="author-location">{item.location ?? "United States"}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
                <div className="testimonial-counter">
                    <div className={sectionDiv0Div1Div0ClassName ?? "row row-cols-2 row-cols-md-3 row-cols-lg-5 g-4"}>
                        {renderCollectionNode(
                            testimonialSectionCounters,
                            (item: TestimonialSectionCountersItem) => (
                                <div className={item.divClassName ?? "counter-item text-center"} key={item.key}>
                                    {renderItemNode(testimonialSectionCountersH4Visible, testimonialSectionCountersH4Renderer, item, (
                                        <h4 className={item.className} {...(typeof testimonialSectionCountersH4Props === "function" ? testimonialSectionCountersH4Props(item) : (testimonialSectionCountersH4Props ?? {}))} {...(typeof divH40H4Props === "function" ? divH40H4Props(item) : (divH40H4Props ?? {}))}>{item.h40Text}</h4>
                                    ))}
                                    <p>{item.p0Text}</p>
                                </div>
                            ),
                            testimonialSectionCountersItemWrapper,
                            testimonialSectionCountersRenderer
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeOneTestimonialSectionGenerated;
